import styled from 'styled-components/macro'

import LogoImage from 'legacy/assets/svg/icons/icon_logo_loadsmart.svg'

import { PORTAL_BASE_PATH } from 'shipperguide/core/domain/PortalRoute'

interface LogoLinkProps {
  isVisible?: boolean
}

const LogoLink = styled.a<LogoLinkProps>`
  transition: all 300ms ease-in;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`

interface LogoProps {
  isVisible?: boolean
}

export function Logo(props: LogoProps) {
  const { isVisible = true, ...restProps } = props

  return (
    <LogoLink
      isVisible={isVisible}
      href={`#${PORTAL_BASE_PATH}/shipments?utm_source=carrierguide&utm_medium=link_menu&utm_campaign=all_in_one`}
      {...restProps}
    >
      <h1>
        <img src={LogoImage} alt="Loadsmart" />
      </h1>
    </LogoLink>
  )
}
